<div class="side-menu">
  <tds-side-menu aria-label="Side menu" id="side-menu" persistent [open]="isMenuOpened()">
    <tds-side-menu-overlay slot="overlay" (click)="mobileMenuAction(false)"></tds-side-menu-overlay>
    <tds-side-menu-close-button
      slot="close-button"
      aria-label="Close drawer menu"
      (click)="mobileMenuAction(false)"
    ></tds-side-menu-close-button>
    @for (menu of menus; track menu.title) {
      @if (menu.subMenu && hasVisibleChildren(menu)) {
        <tds-side-menu-dropdown id="wheel-types-dropdown" default-closed>
          <tds-icon slot="icon" [name]="menu.icon" size="24px"></tds-icon>
          <span slot="label">{{ menu.title | translate }}</span>
          <tds-side-menu-dropdown-list>
            @for (sub of menu.subMenu; track sub.title) {
              @if (canShowItem(sub)) {
                <tds-side-menu-dropdown-list-item [selected]="selectedMenu() === sub.path">
                  <a [routerLink]="sub.path" (click)="handleMenuLinkClick($event, sub.path!)">{{
                    sub.title | translate
                  }}</a>
                </tds-side-menu-dropdown-list-item>
              }
            }
          </tds-side-menu-dropdown-list>
        </tds-side-menu-dropdown>
      } @else if (canShowItem(menu)) {
        <tds-side-menu-item [selected]="selectedMenu() === menu.path">
          <a [routerLink]="menu.path" (click)="handleMenuLinkClick($event, menu.path!)">
            <tds-icon [name]="menu.icon" size="24px"></tds-icon>
            {{ menu.title | translate }}
          </a>
        </tds-side-menu-item>
      }
    }

    <div slot="end">
      <tds-side-menu-dropdown>
        <a slot="icon">
          <p slot="icon">{{ selectedArea()?.name || ('templates.noArea' | translate) }}</p>
        </a>
        @for (area of areas(); track area.id) {
          <tds-side-menu-dropdown-list-item
            [selected]="selectedArea()?.id === area.id ? '' : null"
            (click)="selectedArea()?.id !== area.id && changeArea(area.id)"
          >
            <a> {{ area.name }} </a>
          </tds-side-menu-dropdown-list-item>
        }
      </tds-side-menu-dropdown>
    </div>

    <div slot="end">
      <tds-side-menu-dropdown>
        <a slot="icon">
          @if (currentLanguage$ | async; as current) {
            <div class="tds-u-flex tds-u-gap1">
              <tds-icon name="language"></tds-icon>
              <p class="tds-u-m0">{{ current.name | translate }}</p>
            </div>
          }
        </a>
        @if (currentLanguage$ | async; as current) {
          @for (language of languages; track language.value) {
            <tds-side-menu-dropdown-list-item
              [selected]="current.value === language.value ? '' : null"
              (click)="current.value !== language.value && changeTranslation(language.value)"
            >
              <a>
                <span [class]="language.flag"></span>
                <div class="tds-u-pl1">{{ language.name | translate }}</div>
              </a>
            </tds-side-menu-dropdown-list-item>
          }
        }
      </tds-side-menu-dropdown>
    </div>

    <div slot="end">
      <tds-side-menu-dropdown>
        @if (userphoto()) {
          <img
            slot="icon"
            [src]="userphoto()"
            alt="User avatar"
            height="34"
            width="34"
            class="user-avatar"
          />
        } @else {
          <tds-icon slot="icon" name="profile" size="24px"></tds-icon>
        }
        <tds-side-menu-user slot="label" [heading]="username()" [subheading]="useremail()">
        </tds-side-menu-user>
        <tds-side-menu-dropdown-list-item (click)="toggleTheme()">
          <a>
            @if (theme.isDark()) {
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
                <path
                  d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path d="M12 2v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <path d="M12 20v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <path
                  d="M4.93 4.93l1.41 1.41"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M17.66 17.66l1.41 1.41"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path d="M2 12h2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <path d="M20 12h2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <path
                  d="M4.93 19.07l1.41-1.41"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
                <path
                  d="M17.66 6.34l1.41-1.41"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            } @else {
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
                <g transform="translate(-2 0)">
                  <path
                    d="M21 13.2A7.5 7.5 0 0 1 10.8 3 a6.9 6.9 0 1 0 10.2 10.2Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
              </svg>
            }
            <div class="tds-u-pl1">
              {{ (theme.isDark() ? 'theme.light' : 'theme.dark') | translate }}
            </div>
          </a>
        </tds-side-menu-dropdown-list-item>
        <tds-side-menu-dropdown-list-item (click)="logout()">
          <a>
            <tds-icon name="exit"></tds-icon>
            <div class="tds-u-pl1">{{ 'menu.logout' | translate }}</div>
          </a>
        </tds-side-menu-dropdown-list-item>
      </tds-side-menu-dropdown>
    </div>

    <tds-side-menu-collapse-button slot="sticky-end">{{
      'menu.collapse' | translate
    }}</tds-side-menu-collapse-button>
  </tds-side-menu>
</div>
